export enum ModalStates {
  Closed = "closed",
  BreakDateSelect = "breakDateSelect",
  CustomerAndHeadAgreementSelect = "customerAndHeadAgreementSelect",
  ConfirmDelete = "confirmDelete",
  Update = "update",
  NewRouteAgreement = "newRouteAgreement",
}
